// extracted by mini-css-extract-plugin
export default {"winContainer":"WinComponent_winContainer__W6591","winImg":"WinComponent_winImg__ntHYD"};